import React from 'react'
import "./ourServeces.css"
import { useMediaQuery } from "react-responsive";

export default function Donations() {
    const isDesktopOrLaptop = useMediaQuery({
        query: '(min-width: 1224px)'
    })
    const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
    const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
    const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })

     return (
             <div className='servece-main'>
                 <section style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                     <section className='card-servece-contact'>
                 <h1 style={{color: '#ffa400'}}>Thank you</h1>
                         {isDesktopOrLaptop && <span className='contacts'>
                             <div>
                                 <h3 style={{ color: 'white' }}>Sham Cash</h3>
                                 <h5 style={{ color: 'white', fontSize:15 }}>------------</h5>
                             </div>
                         </span>}
                         {isTabletOrMobile && <span className='contacts-mobile'>
                             <div>
                                 <h3 style={{ color: 'white' }}>Sham Cash</h3>
                                 <h5 style={{ color: 'white', fontSize:15  }}>------------</h5>
                             </div>
                         </span>}
                     </section>
                 </section>
             </div>
         )
}
